import settings from "configs/settings";

function clg() {
    if( settings.debug ) {
        const length = arguments.length;

        [...arguments].forEach(function (value, key) {
            if( typeof value === "string") {
                /* console.log(
                    '%c'+ value +'',
                    'color: #fff; background: #1e90ff; padding: 4px'
                ); */
                console.log(value);
            } else {
                console.log( value );
            }

            //clg blokk végén új sor beszúrása
            if( key === length - 1 ) console.log("\n");
        });
    }
}

export default clg;